module.exports = __webpack_public_path__ + "static/media/29FUNOV11.ef64febe.jpg";